import { hot } from 'react-hot-loader';

import 'url-search-params-polyfill';

import App from './app';

export default hot(module)(App);
